import animateScroll from "react-scroll/modules/mixins/animate-scroll";

export const SCROLL_DURATION = 500;

export const productsScroll = () => {
  animateScroll.scrollTo(0, {
    duration: 500
  });
};
